// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  requestId: __t.u64().name("request_id"),
  agentIdentity: __t.identity().name("agent_identity"),
  userIdentity: __t.identity().name("user_identity"),
  sessionId: __t.u64().name("session_id"),
  audience: __t.string(),
  requestedAt: __t.timestamp().name("requested_at"),
});
